module.exports = {
    YES : 'YES',
    NO : 'NO',
    EMPTY: ''
};
